define(function(require) {

    const PROD_SERVER_URL = "https://infogeo.education.gouv.qc.ca",
          DEV_SERVER_URL = "https://carto48dev.education.gouv.qc.ca",
          SERVER = document.location.origin === PROD_SERVER_URL ? "PROD" : "DEV",
          CARTE_GDUNO_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/CARTE_GDUNO/FeatureServer",
          DECOUPAGE_EDITION_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/DECOUPAGE_EDITION_SERVICES/GPServer",
          DECOUPAGE_QUERY_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/DECOUPAGE_QUERY_SERVICES/GPServer",
          AUTH_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/AUTH_SERVICES/GPServer",
          NETWORK_ANALYST_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/NETWORK_ANALYST_SERVICES/GPServer",
          LOGGER_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/LOGGER_SERVICES/GPServer",
          PRIVATE_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/SPES_Provincial/GPServer";

    return {
        APP_NAME: "Decoupage_SPES",
        URLS: {
            AUTH: {
                LOGIN: AUTH_SERVICES_URL + "/Login/execute",
                LOGOUT: AUTH_SERVICES_URL + "/Logout/execute",
                PING: AUTH_SERVICES_URL + "/Ping/execute"
            },
            LOGGER: {
                LOG_CLIENT_ERROR: LOGGER_SERVICES_URL + "/LogClientError/execute"
            },
            EDITION: {
                UPDATE_POINTS: DECOUPAGE_EDITION_SERVICES_URL + "/UpdateFeatures_GEO07E12_POINTS_SPES/execute",
                UPDATE_LINES: DECOUPAGE_EDITION_SERVICES_URL +"/UpdateFeatures_GEO07E13_LINES_SPES/execute",
                UPDATE_ANNOTATIONS: DECOUPAGE_EDITION_SERVICES_URL + "/UpdateFeatures_GEO07E14_ANNOTATIONS_SPES/execute",
                UPDATE_SECTORS: DECOUPAGE_EDITION_SERVICES_URL + "/UpdateFeatures_GEO07E17_SECTORS_DATA_SPES/execute",
                ADD_LINES: DECOUPAGE_EDITION_SERVICES_URL + "/AddFeatures_GEO07E13_LINES_SPES/execute",
                ADD_ANNOTATIONS: DECOUPAGE_EDITION_SERVICES_URL + "/AddFeatures_GEO07E14_ANNOTATIONS_SPES/execute",
                ADD_SECTORS: DECOUPAGE_EDITION_SERVICES_URL + "/AddFeatures_GEO07E17_SECTORS_DATA_SPES/execute",
                DELETE_LINES: DECOUPAGE_EDITION_SERVICES_URL + "/DeleteFeatures_GEO07E13_LINES_SPES/execute",
                DELETE_ANNOTATIONS: DECOUPAGE_EDITION_SERVICES_URL + "/DeleteFeatures_GEO07E14_ANNOTATIONS_SPES/execute",
                DELETE_SECTORS: DECOUPAGE_EDITION_SERVICES_URL + "/DeleteFeatures_GEO07E17_SECTORS_DATA_SPES/execute"
            },
            QUERY_LAYERS: {
                GEO03E07_CP_REFRN : PRIVATE_SERVICES_URL + "/Query_GEO03E07_CP_REFRN/execute",
                GEO03E09_ADRS : PRIVATE_SERVICES_URL + "/Query_GEO03E09_ADRS/execute",
                GEO07E12_POINTS_SPES: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO07E12_POINTS_SPES/execute",
                GEO07E13_LINES_SPES: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO07E13_LINES_SPES/execute",
                GEO07E14_ANNOTATIONS_SPES: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO07E14_ANNOTATIONS_SPES/execute",
                GEO07E16_POINTS_0_4_ANS_SPES: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO07E16_POINTS_0_4_ANS_SPES/execute",
                GEO07E15_SECT_SPES: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO07E15_SECT_SPES/execute",
                GEO09E32_GDUNO_IMMBL: CARTE_GDUNO_SERVICES_URL + "/0/query",
                GEO09E56_ZONES_GRISES: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E56_ZONES_GRISES/execute",
                GEO09E35_SECT_FRA: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E35_SECT_FRA/execute",
                GEO09E36_SECT_ANG: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E36_SECT_ANG/execute",
                GEO09E37_SECT_STA: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E37_SECT_STA/execute",
                GEO09E35_SECT_FRA_ZG: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E35_SECT_FRA/execute",
                GEO09E01_CS_FRA: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E01_CS_FRA/execute",
                GEO09E02_CS_ANG: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E02_CS_ANG/execute",
                GEO09E03_CS_STA: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E03_CS_STA/execute",
                GEO09E66_TERRI_ANA_PP_FRA : DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E66_TERRI_ANA_PP_FRA/execute",
                GEO09E67_TERRI_ANA_PP_ANG : DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E67_TERRI_ANA_PP_ANG/execute",
                GEO09E69_TERRI_ANA_S_FRA : DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E69_TERRI_ANA_S_FRA/execute",
                GEO09E70_TERRI_ANA_S_ANG: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO09E70_TERRI_ANA_S_ANG/execute",
                GEO07E21_SCENARIOS : DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO07E21_SCENARIOS/execute",
                GEO07E20_BASSINS: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO07E20_BASSINS/execute"
            },
            QUERY_STORES: {
                GEO07E17_SECTORS_DATA_SPES: DECOUPAGE_QUERY_SERVICES_URL + "/Query_GEO07E17_SECTORS_DATA_SPES/execute",
            },
            DOWNLOAD: {
                GEO07E15_SECT_SPES: DECOUPAGE_QUERY_SERVICES_URL + "/Download_GEO07E15_SECT_SPES/execute",
                AD_SPES: DECOUPAGE_QUERY_SERVICES_URL + "/Download_AD_SPES/execute",
                LOTS_SPES_FRA_STA: DECOUPAGE_QUERY_SERVICES_URL + "/Download_LOTS_SPES_FRA_STA/execute",
            },
            NETWORK_ANALYST: {
                SERVICE_AREAS: NETWORK_ANALYST_SERVICES_URL + "/Service_Areas/execute",
                FIND_ROUTES: NETWORK_ANALYST_SERVICES_URL + "/Find_Routes/execute"
            }
        },
        LAYERS: {
            GEO09E70_TERRI_ANA_S_ANG : require("configs/layers/GEO09E70_TERRI_ANA_S_ANG"),
            GEO09E69_TERRI_ANA_S_FRA : require("configs/layers/GEO09E69_TERRI_ANA_S_FRA"),
            GEO09E67_TERRI_ANA_PP_ANG : require("configs/layers/GEO09E67_TERRI_ANA_PP_ANG"),
            GEO09E66_TERRI_ANA_PP_FRA : require("configs/layers/GEO09E66_TERRI_ANA_PP_FRA"),
            GEO09E03_CS_STA: require("configs/layers/GEO09E03_CS_STA"),
            GEO09E02_CS_ANG: require("configs/layers/GEO09E02_CS_ANG"),
            GEO09E01_CS_FRA: require("configs/layers/GEO09E01_CS_FRA"),
            GEO07E15_SECT_SPES: require("configs/layers/GEO07E15_SECT_SPES"),
            GEO09E37_SECT_STA: require("configs/layers/GEO09E37_SECT_STA"),
            GEO09E36_SECT_ANG: require("configs/layers/GEO09E36_SECT_ANG"),
            GEO09E35_SECT_FRA: require("configs/layers/GEO09E35_SECT_FRA"),
            GEO09E35_SECT_FRA_ZG: require("configs/layers/GEO09E35_SECT_FRA_ZG"),
            GEO09E56_ZONES_GRISES: require("configs/layers/GEO09E56_ZONES_GRISES"),
            GEO07E21_SCENARIOS : require("configs/layers/GEO07E21_SCENARIOS"),
            GEO07E20_BASSINS : require("configs/layers/GEO07E20_BASSINS"),
            SERVICE_AREAS: require("configs/layers/SERVICE_AREAS"),
            FIND_ROUTES: require("configs/layers/FIND_ROUTES"),
            FIND_ROUTES_STOPS: require("configs/layers/FIND_ROUTES_STOPS"),
            GEO07E16_POINTS_0_4_ANS_SPES: require("configs/layers/GEO07E16_POINTS_0_4_ANS_SPES"),
            GEO07E16_POINTS_4_ANS_SPES: require("configs/layers/GEO07E16_POINTS_4_ANS_SPES"),
            GEO07E16_POINTS_3_ANS_SPES: require("configs/layers/GEO07E16_POINTS_3_ANS_SPES"),
            GEO07E16_POINTS_2_ANS_SPES: require("configs/layers/GEO07E16_POINTS_2_ANS_SPES"),
            GEO07E16_POINTS_1_AN_SPES: require("configs/layers/GEO07E16_POINTS_1_AN_SPES"),
            GEO07E16_POINTS_0_AN_SPES: require("configs/layers/GEO07E16_POINTS_0_AN_SPES"),
            GEO07E12_POINTS_SPES: require("configs/layers/GEO07E12_POINTS_SPES"),
            GEO09E32_GDUNO_IMMBL: require("configs/layers/GEO09E32_GDUNO_IMMBL"),
            GEO03E07_CP_REFRN : require("configs/layers/GEO03E07_CP_REFRN"),
            GEO03E09_ADRS : require("configs/layers/GEO03E09_ADRS"),
            DRAWING_LAYER: require("configs/layers/DRAWING_LAYER"),
            GEO07E13_LINES_SPES: require("configs/layers/DRAWING_LAYER").LINES,
            GEO07E14_ANNOTATIONS_SPES: require("configs/layers/DRAWING_LAYER").ANNOTATIONS,
        },
        DATASTORES: {
            SECTORS_DATA: {
                ID: "sectorsDataStore",
                TOKEN_REQUIRED: true,
                TABLE_ID : "GEO07E17_SECTORS_DATA_SPES",
                QUERY_FIELDS : ["GUID", "SECTEUR", "SCENARIO", "COULEUR", "DESCRIPTION"],
                ATTRIBUTES : {
                    ID : "GUID",
                    SCENARIO : "SCENARIO",
                    GROUP : "SECTEUR",
                    CODE : "SECTEUR",
                    COLOR : "COULEUR",
                    DESCRIPTION : "DESCRIPTION"
                }
            }
        },
        LOCALES: {
            POINTS: {
                NAMES : {
                    SHORT_SINGLE : "élève",
                    SHORT_PLURAL : "élèves",
                    LONG_SINGLE : "élève",
                    LONG_PLURAL : "élèves"
                }
            },
            SECTORS: {
                SECTOR : {
                    NAMES : {
                        SHORT_SINGLE : "secteur",
                        SHORT_PLURAL : "secteur",
                        LONG_SINGLE : "secteur de prévision des effectifs scolaires",
                        LONG_PLURAL : "secteurs de prévision des effectifs scolaires"
                    }
                },
                GROUP : {
                    NAMES : {
                        SHORT_SINGLE : "secteur",
                        SHORT_PLURAL : "secteur",
                        LONG_SINGLE : "secteur de prévision des effectifs scolaires",
                        LONG_PLURAL : "secteurs de prévision des effectifs scolaires"
                    }
                }
            }
        },
        THEMESETS_ELEMENTS: {
            SCENARIO_1: require("configs/themeSetsElements/SCENARIO_1"),
            SCENARIO_2: require("configs/themeSetsElements/SCENARIO_2"),
            SCENARIO_3: require("configs/themeSetsElements/SCENARIO_3"),
            PREVISIONS: require("configs/themeSetsElements/PREVISIONS")
        },
        APP_TOOLS: {
            GUIDE_PDF: "documents/Guide_Decoupage_SPES.pdf",
            AUTH_SESSION: {
                USER: {TOKEN:""}
            },
            CLIENT_ERRORS_LOGGER: {
                ENABLE: true
            },
            DOWNLOAD_SHAPEFILE : require("configs/appTools/DownloadShapefileConfig")
        },
        MAP_TOOLS: {
            SELECTION_STATS : require("configs/mapTools/SelectionStatsConfig"),
            BASEMAP_TOGGLE: [
                {ID: "carte", BASEMAPLAYERS_IDS: ["Fondstuiles_2"], INITIAL: true, COPYRIGHTS_IMAGERIE: false},
                {ID: "hybride", BASEMAPLAYERS_IDS: ["Fondstuiles_2", "Fondstuiles_1"], INITIAL: false, COPYRIGHTS_IMAGERIE: true},
                {ID: "imagerie", BASEMAPLAYERS_IDS: ["Fondstuiles_1"], INITIAL: false, COPYRIGHTS_IMAGERIE: true}
            ],
            INFO_MODAL: {
                MODAL_TITLE: "Fiche(s) de renseignement",
                MAX_FEATURES_PER_LAYER: 20,
                EFFECTIFS_ACTUAL_YEAR: 2025,
                LAYERS: [
                    require("configs/mapTools/infoModal/GEO09E35_SECT_FRA"),
                    require("configs/mapTools/infoModal/GEO09E35_SECT_FRA_ZG"),
                    require("configs/mapTools/infoModal/GEO09E36_SECT_ANG"),
                    require("configs/mapTools/infoModal/GEO09E37_SECT_STA"),
                    require("configs/mapTools/infoModal/GEO09E56_ZONES_GRISES"),
                    require("configs/mapTools/infoModal/GEO09E01_CS_FRA"),
                    require("configs/mapTools/infoModal/GEO09E02_CS_ANG"),
                    require("configs/mapTools/infoModal/GEO09E03_CS_STA"),
                ]
            }
        },
        PANELS: {
            DECOUPAGE_PANEL: {
                POINTS: {
                    LAYER_ID: "GEO07E12_POINTS_SPES",
                    DATATABLE_ID: "t_GEO07E12_POINTS_SPES",
                    SUM_DATACOLUMN_ID: "NBR_ELEVES",
                    SCENARIOS_DATACOLUMNS : {
                        SCENARIO_1: {THEME: "THEME_SCENARIO_1", SECTOR: "SECTEUR_SC1", GROUP: "SECTEUR_SC1"},
                        SCENARIO_2: {THEME: "THEME_SCENARIO_2", SECTOR: "SECTEUR_SC2", GROUP: "SECTEUR_SC2"},
                        SCENARIO_3: {THEME: "THEME_SCENARIO_3", SECTOR: "SECTEUR_SC3", GROUP: "SECTEUR_SC3"}
                    }
                },
                INCLUDE_STATISTICS: false,
                TWO_LEVELS: false
            },
            FIND_ROUTES: require("configs/panels/FindRoutesConfig"),
            SERVICE_AREAS: require("configs/panels/ServiceAreasConfig")
        },
        MAP : {
            ID : "map1",
            INITIAL_EXTENT_LAYER : "CS_SPES"
        },
        DEBUG : SERVER === "PROD" ? false : true
    };
});
